import React, { PropsWithChildren } from "react";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import classes from "./styles.module.scss";
import resolvePath from "Utils/resolvePath";
import { Button } from "Components/ReactstrapSlim";
import { SpaceType } from "Services/API/API";
import { Desk, EventSpace, MeetingRoom, Office } from "Components/Icons";

function getColor(fieldValue, value) {
   return fieldValue & value
      ? "check--checked"
      : "check--unchecked"
}

interface SpaceTypeSelectorProps<T extends FieldValues> {
   control: Control<T>,
   name: FieldPath<T>,
   disabled?: boolean
}

export const SpaceTypeSelector = <T extends FieldValues,>({ control, name, disabled, ...rest }: PropsWithChildren<SpaceTypeSelectorProps<T>>) => {
   return <Controller control={control} name={name} render={({ field, formState: { errors } }) => {
      const error = resolvePath(errors, name);
      return <div className={classes.container}>
         <input type="hidden" value={field.value} />
         {error ? <div className={classes.error}>{error.message}</div> : null}
         <Button disabled={disabled} className={classes.button} onClick={ev => { ev.preventDefault(); field.onChange(field.value ^ SpaceType.Desk); }} color={getColor(field.value, SpaceType.Desk)}>
            <Desk />
            Desk
         </Button>
         <Button disabled={disabled} className={classes.button} onClick={ev => { ev.preventDefault(); field.onChange(field.value ^ SpaceType.Office); }} color={getColor(field.value, SpaceType.Office)}>
            <Office />
            Office
         </Button>
         <Button disabled={disabled} className={classes.button} onClick={ev => { ev.preventDefault(); field.onChange(field.value ^ SpaceType.Meeting); }} color={getColor(field.value, SpaceType.Meeting)}>
            <MeetingRoom />
            Meeting Room
         </Button>
         <Button disabled={disabled} className={classes.button} onClick={ev => { ev.preventDefault(); field.onChange(field.value ^ SpaceType.EventSpace); }} color={getColor(field.value, SpaceType.EventSpace)}>
            <EventSpace />
            Event Space
         </Button>
      </div>
   }}
   />
}

export default SpaceTypeSelector;